/* tslint:disable */
/* eslint-disable */
/**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BulkEditRequestBulkEditContributionsInner
 */
export interface BulkEditRequestBulkEditContributionsInner {
    /**
     * 
     * @type {string}
     * @memberof BulkEditRequestBulkEditContributionsInner
     */
    op: BulkEditRequestBulkEditContributionsInnerOpEnum;
    /**
     * 
     * @type {string}
     * @memberof BulkEditRequestBulkEditContributionsInner
     */
    role: string;
    /**
     * Alias id from lookup_client_aliases (4.2.2). Required for op=add.
     * @type {string}
     * @memberof BulkEditRequestBulkEditContributionsInner
     */
    personaId?: string | null;
    /**
     * Data quality "1".."5" ("1" = Verified)
     * @type {string}
     * @memberof BulkEditRequestBulkEditContributionsInner
     */
    dataCategory?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BulkEditRequestBulkEditContributionsInner
     */
    sourceUrl?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BulkEditRequestBulkEditContributionsInner
     */
    notes?: string | null;
}


/**
 * @export
 */
export const BulkEditRequestBulkEditContributionsInnerOpEnum = {
    Add: 'add',
    Edit: 'edit',
    Replace: 'replace',
    Delete: 'delete'
} as const;
export type BulkEditRequestBulkEditContributionsInnerOpEnum = typeof BulkEditRequestBulkEditContributionsInnerOpEnum[keyof typeof BulkEditRequestBulkEditContributionsInnerOpEnum];


/**
 * Check if a given object implements the BulkEditRequestBulkEditContributionsInner interface.
 */
export function instanceOfBulkEditRequestBulkEditContributionsInner(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "op" in value;
    isInstance = isInstance && "role" in value;

    return isInstance;
}

export function BulkEditRequestBulkEditContributionsInnerFromJSON(json: any): BulkEditRequestBulkEditContributionsInner {
    return BulkEditRequestBulkEditContributionsInnerFromJSONTyped(json, false);
}

export function BulkEditRequestBulkEditContributionsInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): BulkEditRequestBulkEditContributionsInner {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'op': json['op'],
        'role': json['role'],
        'personaId': !exists(json, 'persona_id') ? undefined : json['persona_id'],
        'dataCategory': !exists(json, 'data_category') ? undefined : json['data_category'],
        'sourceUrl': !exists(json, 'source_url') ? undefined : json['source_url'],
        'notes': !exists(json, 'notes') ? undefined : json['notes'],
    };
}

export function BulkEditRequestBulkEditContributionsInnerToJSON(value?: BulkEditRequestBulkEditContributionsInner | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'op': value.op,
        'role': value.role,
        'persona_id': value.personaId,
        'data_category': value.dataCategory,
        'source_url': value.sourceUrl,
        'notes': value.notes,
    };
}

